import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { Currency } from '../../models/Flight/Currency';

const AVIASALES_HOST = process.env.REACT_APP_AVIASALES_HOST;
const AVIASALES_KEY = process.env.REACT_APP_AVIASALES_KEY;

export const REQUEST_CURRENCIES = 'FLIGHTS_REQUEST_CURRENCIES';
export const RESPONSE_CURRENCIES = 'FLIGHTS_RESPONSE_CURRENCIES';
export const ERROR_CURRENCIES = 'FLIGHTS_ERROR_CURRENCIES';

export const SET_CURRENCY = 'FLIGHTS_SET_CURRENCY';

export const getCurrenciesAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_CURRENCIES
    });

    try {
        const response = await fetcher(`${AVIASALES_HOST}/api/client/v1/currencies`)
            .auth(`Basic ${AVIASALES_KEY}`)
            .json();

        dispatch({
            type: RESPONSE_CURRENCIES,
            response
        });
    } catch (error) {
        dispatch({
            type: ERROR_CURRENCIES,
            error
        });
    }
};

export const setCurrencyAction = (currency: Currency) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CURRENCY,
        currency
    });
};



// WEBPACK FOOTER //
// ./src/actions/Flight/currencies.ts